module.exports = __webpack_public_path__ + "img/Lazare.512fab3d.jpg";